export default function capitalize(text: string = '') {
  return (text[0] || '').toUpperCase() + (text.substring(1) || '').toLowerCase();
}
